"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUPED_PRODUCT_LINK = exports.GROUPED_PRODUCT = void 0;
const GROUPED_PRODUCT = exports.GROUPED_PRODUCT = 'grouped-product';
const GROUPED_PRODUCT_LINK = exports.GROUPED_PRODUCT_LINK = `grouped-product-link`;
